import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Button, Grid, Header, Icon, Loader, Popup, Table } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoExamTerms = () => <p>Nema ispita.</p>;

export default class ExamsByCourseImpl extends React.Component {
    constructor(props) {
        super(props);
        let storedId = '';
        let storedName = '';
        if (localStorage.getItem('id')) {
            storedId = parseInt(localStorage.getItem('id'), 10);
        }
        if (localStorage.getItem('name')) {
            storedName = parseInt(localStorage.getItem('name'), 10);
        }

        this.state = {
            data: [],
            id: storedId,
            name: storedName,
            loading: true
        };

        this.getExams = this.getExams.bind(this);
        this.removeExam = this.removeExam.bind(this);
    }

    componentDidMount() {
        window.localStorage.removeItem('gradedActivityId');
        window.localStorage.removeItem('courseImplementationName');
        window.localStorage.removeItem('gradedActivityName');
        window.localStorage.removeItem('date');

        if (localStorage.getItem('id')) { this.getExams(parseInt(localStorage.getItem('id'), 10)); } else {
            this.getExams(this.props.id);
            localStorage.setItem('id', this.props.id);
            localStorage.setItem('name', this.props.name);
        }
    }

    getExams(id) {
        axios.get(`exams/graded-activities/${parseInt(localStorage.getItem('academicYear'), 10)}/${id}`)
            .then(res => {
                this.setState({ data: res.data, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch exams');
            });
    }

    removeExam(id, id_) {
        let obj = {
            gradedActivity: { id },
            gradedActivityRegistrationDate: { id: id_ }
        };

        axios.delete('/exams/delete', { data: obj })
            .then(res => {
                toast('Uspješno ste obrisali ispit.');
                this.getExams(parseInt(localStorage.getItem('id'), 10));
            })
            .catch(err => {
                if (err.response.data === 'Could not delete exam. Students were registered exam.') {
                    toast('Ispit nije obrisan jer ima prijavljenih studenata.');
                } else if (err.response.data === 'Could not delete GradedActivityGradedActivityRegistrationDate.') {
                    toast('Došlo je do greške! Ispit nije izbrisan.');
                } else if (err.response.data === 'Could not delete StaffGradedActivity.') {
                    toast('Došlo je do greške! Ispit nije izbrisan.');
                } else toast('Došlo je do greške! Ispit nije izbrisan.');
            });
    }


    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                {this.state.data.length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width="1">R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2">Naziv predmeta</Table.HeaderCell>
                                <Table.HeaderCell>Datum i vrijeme ispita</Table.HeaderCell>
                                <Table.HeaderCell width="2">Tip ispita</Table.HeaderCell>
                                {/* <Table.HeaderCell> */}
                                {/*    <Header as="h4" image> */}
                                {/*        <Header.Content> */}
                                {/*            Datum ponovnog otvaranja ispita */}
                                {/*            <Header.Subheader>(odluka)</Header.Subheader> */}
                                {/*        </Header.Content> */}
                                {/*    </Header> */}
                                {/* </Table.HeaderCell> */}
                                <Table.HeaderCell>Datum ponovnog otvaranja ispita (odluka)</Table.HeaderCell>
                                <Table.HeaderCell>Napomena</Table.HeaderCell>
                                {(localStorage.getItem('previous') === 'false' || localStorage.getItem('thirdCycle') === 'true' || localStorage.getItem('specialist') === 'true') && <Table.HeaderCell />}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>  {this.state.data.map((el, index) =>
                            (<Table.Row >
                                <Table.Cell verticalAlign="middle">
                                    {index + 1}.
                                </Table.Cell>
                                <Popup
                                    content={el.semesterNameKey === 'winter semester' ? 'Implementacija predmeta u zimskom semestru' : 'Implementacija predmeta u ljetnom semestru'}
                                    hideOnScroll
                                    position="left center"
                                    trigger={<Table.Cell verticalAlign="middle" colSpan="2">
                                        <Grid columns={1} centered className="stackable">
                                            <Grid.Row verticalAlign="middle">
                                                <Grid.Column width="10">
                                                    <span >  { el.semesterNameKey === 'winter semester' ? <Icon name="snowflake" color="blue" /> : <Icon name="sun" color="yellow" />}{el.courseImplementationName}</span>
                                                </Grid.Column>
                                                <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                    <span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                    </Table.Cell>}
                                />
                                <Table.Cell verticalAlign="middle">
                                    {moment(el.gradedActivityDate).format('D. M. YYYY. - HH:mm')}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.gradedActivityName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.finalizationCancelDate ? moment(el.finalizationCancelDate).format('D. M. YYYY.') + '\n' : ''}
                                    {el.documentNumber ? ' ( Odluka: ' + el.documentNumber + ')' : ''}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.comment}
                                </Table.Cell>
                                {(localStorage.getItem('previous') === 'false' || localStorage.getItem('thirdCycle') === 'true' || localStorage.getItem('specialist') === 'true') &&
                                <Table.Cell verticalAlign="middle" textAlign="center">
                                    <Link to={{
                                        pathname: '/kreiranje-i-prikaz-ispita-po-predmetima/detalji',
                                        state: { exam: el }
                                    }}
                                    >
                                        <Popup
                                            content="Detalji"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    icon="align justify"
                                                    size="small"
                                                    color="blue"
                                                    onClick={() => {
                                                        localStorage.setItem('gradedActivityId', el.gradedActivityId);
                                                        localStorage.setItem('courseImplementationName', el.courseImplementationName);
                                                        localStorage.setItem('gradedActivityName', el.gradedActivityName);
                                                        localStorage.setItem('gradedActivityDate', el.gradedActivityDate);
                                                        localStorage.setItem('courseImplementationId', el.courseImplementationId);
                                                        localStorage.setItem('classroom', el.classroom ? el.classroom : '');
                                                        localStorage.setItem('comment', el.comment ? el.comment : '');
                                                        localStorage.setItem('gradingMethodId', el.gradingMethodId);
                                                        localStorage.setItem('gradedActivityTypeId', el.gradedActivityTypeId);
                                                        localStorage.setItem('gradedActivityRegistrationDateStart', el.gradedActivityRegistrationDateStart);
                                                        localStorage.setItem('gradedActivityRegistrationDateEnd', el.gradedActivityRegistrationDateEnd);
                                                        localStorage.setItem('gradedActivityRegistrationClosing', el.gradedActivityRegistrationClosing);
                                                        localStorage.setItem('optLock', el.optLock);
                                                    }}
                                                />}
                                        />
                                    </Link>
                                    <Popup
                                        content="Brisanje"
                                        position="top center"
                                        trigger={
                                            <Button
                                                basic="true"
                                                circular
                                                icon="trash alternate"
                                                size="small"
                                                color="red"
                                                onClick={() => this.removeExam(el.gradedActivityId, el.gradedActivityRegistrationDateId)}
                                            />}
                                    />


                                </Table.Cell>}
                            </Table.Row>))
                        }
                        </Table.Body>
                    </Table>
                    : <NoExamTerms />
                }
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/ExamsByCourseImpl.js